import React from "react";
import { ManageAIModelsContent } from "../components/AIMaster/ManageAIModelsContent";
import { ToastContainer } from "react-toastify";

export const AIModelMasters = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAIModelsContent />
        </div>
      </div>
    </div>
  );
};
